import { DEFAULT_RUNSTYLE } from '../../../../../CanvasState/Helpers/Text/Config/defaultStyles';

const getCharSpacing = shape => shape.get('charSpacing', null) || DEFAULT_RUNSTYLE.get('characterSpacing');

export default getCharSpacing;
